module.exports = __webpack_public_path__ + "static/media/59_tn.da9c95e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/59_tn.jpg
// module id = 367
// module chunks = 0